import { Platform } from 'ionic-angular';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, PopoverController } from 'ionic-angular';
import { MiddlewareService } from '../../../services/middleware.service';
import { Storage } from '@ionic/storage';
import { ChecklistPage } from '../../checklist/checklist';
import * as Fuse from 'fuse.js';
import { eGENA_Checkliste } from '../../../visionet/Checkliste'
import { SingletonKlickhandlerService } from '../../../services/klickhandler.service';
import { TEILNEHMERKENNUNG_GENERISCH } from '../../../visionet/TeilnehmerInfo';
import { version } from '../../../../package.json';
import { config } from '../../../../package.json';
import { eGENA_Teilnehmerspezifisches } from '../../../visionet/Teilnehmerspezifisches';
import { HaftungsausschlussPopup } from '../../../components/popups/HaftungsausschlussPopup';
import { KlinikkennungEingabePopup } from '../../../components/popups/KlinikkennungEingabePopup';
import { applicationLifetimeStorageName, kenntnisnahmeKey, kenntnisnahmeSpeicherwert } from '../../../app/core/GlobalValues';
import { SearchPhoneSelectListPage } from './SearchPhoneSelectListPage';
import { GlobalsSingleton } from '../../../app/core/GlobalsSingleton';
//import { IonRouterOutlet } from 'ionic-angular';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { GlobalConstants } from '../../../app/core/GlobalConstants';


//@IonicPage()
@Component({
	selector: 'page-phone-search',
	templateUrl: 'SearchPhoneStartPage.html'
})
export class SearchPhoneStartPage {

	fuseOptions = {
		shouldSort: true,
		threshold: 0.15,
		location: 0,
		distance: 200,
		maxPatternLength: 32,
		minMatchCharLength: 3,
		keys: [
			"titel",
			"schlüsselwörterFürAlphabetischeSuche"
		]
	};

	curSearchTerm: string
	fuseSearch: any
	isLoaded: boolean = false;


	ausgewaehlterPatiententyp: string = "" // Kind, Erwachsender oder Schwangere
	patiententypTagToName = {"k": "Kind","e": "Erwachsener", "s":"Schwangere"};

	curSearchResultChecklists: eGENA_Checkliste[];
	activeSearch: string = "";


	//indices
	azIndex: Map<string, eGENA_Checkliste[]> =  new Map();
	abcdeIndex: Map<string, eGENA_Checkliste[]> =  new Map();
	bodynavIndex: Map<string, eGENA_Checkliste[]> =  new Map();
	reanIndex: eGENA_Checkliste[] = []
	fuzzySearchIndex: eGENA_Checkliste[] = []
	checklistIndex: any[] = []



	teilnehmerBezeichnung : string | undefined;
	teilnehmerOrt : string | undefined;

	displayVersion : string;

	testVersion : boolean = false;


	debugMessageHtml : SafeHtml = ""; // Das wird dargestellt.

	
	constructor(public globals: GlobalsSingleton, public sanitizer: DomSanitizer, public platform: Platform, public navCtrl: NavController, public navParams: NavParams, private checklistService: MiddlewareService, public storage: Storage, public popoverCtrl: PopoverController, public klickhandlerSingleton : SingletonKlickhandlerService) {
		let url : string = this.platform.url();
		console.log("SearchPage.init(): URL = '" + url);
		if (!url.includes("teilnehmer")) {
			/*	Wenn die URL die Teilnehmerkennung ehthält gibt es folgende Möglichkeiten:
			 *	1. Es ist eine neue Teilnehmerkennung, es gab schon mal eine andere. Dann war also der Haftungsausschluss schon mal zu sehen.
			 *	2. Es ist der erste Aufruf überhaupt und es wurde eine Teilnehmerkennung in der URL vorgegeben. Dann gibt es nach Speicherung der Teilnehmerkennung und URL-Bereinigung einen neuen Aufruf dieser Seite.
			 *	   Der Hauftungsausschluss wird erst dann präsentiert.
			 *	3. Die URL enthält keine Teilnehmerkennung, dann wird ggf. der Hauftungsausschluss gezeigt, fall er noch nicht bestätigt wurde.
			 */
			console.info("SearchPage.init(): URL enthält keine Teilnehmerkennung, evtl. Haftungsausschluss anzeigen.");

			this.registerHomeButtons();
		}

		if (config.test_version)
			this.testVersion = config.test_version;


		this.displayVersion = version;
		if (this.displayVersion.endsWith(".0"))
			this.displayVersion = this.displayVersion.slice(0, -2);
			
			
			
		this.debugMessageHtml = this.sanitizer.bypassSecurityTrustHtml(globals.getDebugMessage());

			
	}

/*
	ngOnInit() {
console.log("===========================================================================================");
console.log("===                                                                                     ===")
console.log("===   ngOnInit()                                                                        ===");
console.log("===                                                                                     ===")
console.log("===========================================================================================");
      this.routerOutlet.swipeGesture = false;
	}
*/



	private handleHomeButtons() {
		if (this.navCtrl.canGoBack()) {
			this.navCtrl.pop( {
				animate : true,
				animation: "ios-transition"
				}
			);
		}
		else {
			// An dieser Stelle de-registrieren wir den event-Listener wieder, weil beim `goToRoot` implizit wieder eine
			// neue Instanz dieser Page generiert wird und damit wird dann auch der Event-Handler wieder neu registriert.
			window.removeEventListener('popstate', this.klickhandlerSingleton.registeredFunction);
			try {
				this.navCtrl.goToRoot( {
					animate : true,
					animation: "ios-transition"
					}
				).catch((reason) => {
					console.error("goToRoot schlägt fehl, reason = " + reason);
				});
			} catch (e) {
				console.error("catch " + e);
			}
		}
		window.history.pushState({}, '')
		//	#14464 (ende)
	}


	private registerHomeButtons() {
		window.addEventListener('load', function() {
			window.history.pushState({}, '');
			}
		);

		/*	Wir müssen uns GENAU DIESE Materialisation der Funktion 'this.handleHomeButtons.bind(this)' merken.
		 *	Das ".bind(this)" generiert hinter den Kulissen eine neue Funktion, es gilt also:
		 *
		 *		this..handleHomeButtons != this.handleHomeButtons.bind(this)
		 *
		 *	Den Handler benötigen wir instanzübergreifend um ihn späger wieder de-registrieren zu können
		 */
		let eventHandler = this.handleHomeButtons.bind(this);
		window.addEventListener('popstate', eventHandler);
		this.klickhandlerSingleton.registeredFunction = eventHandler;
		//	#14464 (ende)
	}


	zeigeHaftungsausschluss() {
		let applicationLifetimeStorage = new Storage({
			name: applicationLifetimeStorageName,
			storeName: applicationLifetimeStorageName,
			driverOrder: ['indexeddb', 'sqlite', 'websql', 'localstorage']
		});

		applicationLifetimeStorage.get(kenntnisnahmeKey).then((data : string | undefined) => {
			console.info("Haftungsausschluss-Kenntnisnahme: " + data);
			// Warum 
			if (data !== kenntnisnahmeSpeicherwert) {
				let popover = this.popoverCtrl.create(
					HaftungsausschlussPopup,
					// data
					{ "zeigeCheckbox": true },
					//PopoverOptions
					{ cssClass: "haftungsausschluss",
						showBackdrop: true,
						enableBackdropDismiss: false // Hier können wir das Popup NICHT durch Klick in den Hintergrund schließen
					}
				);
				popover.present({
				});
			}
		})
		.catch((e : any) => {
			console.error("Fehler beim Ermitteln des '" + kenntnisnahmeKey + "': " + e);
		});
	}

	async ionViewDidLoad() {
		let url : string = this.platform.url();
		let teilnehmerkennung : string | undefined = undefined;
		if (url.includes("teilnehmer")) {
			console.log("Die Url: '" + url + "', window..location.href = '" + window.location.href + "'");
			/*	Eine URL mit der Teilnehmerkennung als QueryParameter oder als URL-Fragment
				Also alles vor der eigentlichen Teilnehmerkennung verwerfen und nur diese übriglassen.
				https://egena-app.de/12345678  ==>  https://egena-app.de#teilnehmer=12345678  ==>  12345678
			 */
			teilnehmerkennung = url.replace(/.*[#\?]+teilnehmer=/gi, "").trim();
			console.info("Die Teilnehmerkennung '" + teilnehmerkennung + "' wurde per URL vorgegeben.")
		}

		let neueTeilnehmerkennungWurdeVorgegeben : boolean = false;
		if (teilnehmerkennung != undefined) {
			await this.getTeilnehmerkennungFromStorage().then((value : string) => {
				let bisherigeTeilnehmerkennung = value;
				console.info("Bisherige Teilnehmerkennung: '" + bisherigeTeilnehmerkennung + "'");
				// Wenn noch keine Teilnehmerkennung eingegeben wurde, ist die bisherige noch gültig.
				if (!bisherigeTeilnehmerkennung) {
					console.info("Bislang keine Teilnehmerkennung hinterlegt, Teilnehmerkennung '" + teilnehmerkennung + "' per Query-Parameter erhalten");
					neueTeilnehmerkennungWurdeVorgegeben = true;
				}
				else if (bisherigeTeilnehmerkennung !== teilnehmerkennung) {
					console.info("Bislang war als Teilnehmerkennung '" + bisherigeTeilnehmerkennung + "' hinterlegt, neue Teilnehmerkennung '" + teilnehmerkennung + "' per Query-Parameter erhalten");
					neueTeilnehmerkennungWurdeVorgegeben = true;
				}
				else {
					console.info("Die Teilnehmerkennung hat sich nicht geändert, der Query-Parameter '" + teilnehmerkennung + "' Hat keine Auswirkung");
					// Keine neue oder die alte Teionehmerkennung, trotzdem URL bereinigen
					this.urlBereinigen();
				}

				if (neueTeilnehmerkennungWurdeVorgegeben) {
					let popover = this.popoverCtrl.create(
						KlinikkennungEingabePopup,
						// data
						{ "teilnehmerkennungAusUrlFuerAutomatischesSetzen": teilnehmerkennung },
						//PopoverOptions
						{ cssClass: "personalisierung",
							showBackdrop: true,
							enableBackdropDismiss: true
						}
					);
					popover.present({
					});
					popover.onDidDismiss((data: any, role:string) => {
						if (data && data?.goToRoot) {
							let newUrl : string = this.urlBereinigen();
							console.log("Nach dem Setzen der neuen Teilnehmerkennung Weiterleitung nach '" + newUrl + "'")
						}
					});
				}
			})
			.catch(function(e) {
				let fehlermeldung : string = "Beim Versuch die lokal gespeicherte teilnehmerkennung zu ermitteln: Error =" + e.message;
				console.error(fehlermeldung);
				alert(fehlermeldung);
			});
		}

		if (neueTeilnehmerkennungWurdeVorgegeben) {
			this.zeigeHaftungsausschluss();
			// Dann wurde ein neuer Roundtrip angestoßen und die Arbeit ist hier zu Ende
			return;
		}


		// Hier gehts nur weiter wenn keine neue Teilnehmerkennung per URL definiert wurde.
		let level = this.navParams.get('level');
		let curPatientType = this.navParams.get('curPatientType');
		let curSearchType = this.navParams.get('curSearchType');
		console.info("Sind lokal gespeicherte Daten vorhandenund sind diese noch aktuell?");

		if (level == 'patientType' && curPatientType != undefined) {
			this.ausgewaehlterPatiententyp = curPatientType
		}

		if (level == 'searchType' && curSearchType != undefined) {
			this.ausgewaehlterPatiententyp = curPatientType

		}

		/**
		 *	(ds)
		 *	Die App sucht in der lokalen Datenbank nach den Eintrag "UpdateInfo". Wird dieser
		 *	gefunden, dann wurde die Datenbank bereits einmal erfolgreich geladen
		 *	(sl)
		 *	Der Eintrag "UpdateInfo" muss nicht vorhanden sein. Es muss nur danach gesucht
		 *	werden können. Ist der Eintrag noch nicht vorhanden, dann hat `updateInfo`den Wert `null`
		 *	In diesem Fall war wohl noch nie eine Checkliste geladen, wir holen also eine Version vom Server.
		 *	Andernfalls müssten wir beim Server anfragen ob dort eine neuere Version der Checkliste liegt.
		 Im Moment tun wir das aber noch nicht. Wir laden jedes mal eine neue Version.
		 */
		let mussDatenAbrufen : boolean = true; // Wenn am Ende der nachfolgenden Kette noch nichts geladen wurde, dann aber!
		await this.storage.get(GlobalConstants.STORAGE_KEY_AKTUELLE_VERSION).then((currentVersion : string | undefined) => {
			console.info("Lokal gespeicherte AktuelleVersion: " + currentVersion);
			mussDatenAbrufen = false;
			if (currentVersion) {
				console.info("Die aktuelle, lokal gespeicherte Version: '" + currentVersion + "'");

				this.storage.get(GlobalConstants.STORAGE_KEY_TEILNEHMERKENNUNG).then((teilnehmerkennung : string | undefined) => {
					if (teilnehmerkennung) {
						console.info("Die lokal gespeicherte Teilnehmerkennung: '" + teilnehmerkennung + "'");

						// Ist die lokale Version noch aktuell?
						this.checklistService.isCurrentet(teilnehmerkennung, currentVersion).subscribe(true_false => {
							if (true_false) {
								console.info("Die lokale Version ist aktuell");
								this.indizesAusStorageNeuGenerieren(null);
							}
							else {
								console.info("Die lokale Version ist nicht mehr aktuell, Daten vom Server abrufen");
								this.loadNewChecklists(teilnehmerkennung);
							}
						},
						error => {
							this.isLoaded = false;
							let errorMessage = "Die Überprüfung ob die lokal gespeicherte Version aktuell ist schlug fehl: " + JSON.stringify(error, null, 4);
							console.error(errorMessage);
							console.info("Wir behelfen uns, falls vorhanden, mit der zuletzt geladenen Fassung");
							this.indizesAusStorageNeuGenerieren(errorMessage);
						});
					}
					else {
						console.info("Keine lokal gespeicherte Teilnehmerkennung => Alle Daten vom Server laden");
						this.loadNewChecklists(TEILNEHMERKENNUNG_GENERISCH);
					}
				}) // Ende then of this.storage.get(GlobalConstants.STORAGE_KEY_TEILNEHMERKENNUNG)
				.catch(function(e) {
					let fehlermeldung : string = "Beim Versuch die lokal gespeicherte Teilnehmerkennung zu ermitteln: Error =" + e.message;
					console.error(fehlermeldung);
					alert(fehlermeldung);
				})


			}
			else {
				console.info("Keine lokal gespeicherte aktuelle Version => Alle Daten vom Server laden");
				this.loadNewChecklists(TEILNEHMERKENNUNG_GENERISCH);
			}
		}) // Ende then of this.storage.get(GlobalConstants.STORAGE_KEY_AKTUELLE_VERSION)
		.catch(function(e) {
			let fehlermeldung : string = "Beim Versuch die lokal gespeicherte aktuelle Version zu ermitteln: Error =" + e.message;
			console.error(fehlermeldung);
			alert(fehlermeldung);

		})

		if (mussDatenAbrufen) {
			console.info("Keine Teilnehmerkennung oder keine lokale Versionsnummer der Daten bekannt. Die Daten der generischen Version werden initial geladen");
			this.loadNewChecklists(TEILNEHMERKENNUNG_GENERISCH);
		}
	}


	/**	=== Visionet(sl) ==========
	 *	Für den Fall, dass wir keine Verbindung zum Serve bekommen versuchen wir die ganzen Indizes aus dem lokalen Speicher zu holen
	 *	Dazu holen wir die einzelnen Checklisten anhand ihrer ID (die bekommen wir aus `this.storage.get(GlobalConstants.STORAGE_KEY_CHECKLIST_INDEX)`) und
	 *	generieren dann aus jeder gefundenen Checkliste die Indizes.
	 */
	indizesAusStorageNeuGenerieren(grund : string | undefined) : void {
		Promise.all([
			this.storage.get(GlobalConstants.STORAGE_KEY_CHECKLIST_INDEX).then((checklistIndex) => {
				this.checklistIndex = checklistIndex;

				if (checklistIndex != undefined) {
					for (const id of checklistIndex) {
						this.storage.get(id.toString()).then((checkliste : any) => {
							for (const cl of eGENA_Checkliste.fromJSONstring(JSON.stringify(checkliste))) {
								this.checklisteIndizieren(cl);
							}
							this.chcklistenIndizesGlobalSpeichern();
						})
					}
				}
				else {
					this.isLoaded = false;
					let fehlermeldung = "Keine lokal gespeicherten Checklisten gefunden, keine Verbindung zum Server '" + this.checklistService.getDataUrl("<Teilnehmerkennung>") + "'";
					if (grund)
						fehlermeldung = grund + "\n" + fehlermeldung;
					console.error("Keine lokal gespeicherten Checklisten gefunden, keine Verbindung zum Server '" + this.checklistService.getDataUrl("<Teilnehmerkennung>") + "'");
					alert(fehlermeldung);
					//Promise.reject("Keine lokal gespeicherten Checklisten gefunden, keine Verbindung zum Server '" + this.checklistService.getDataUrl() + "'");
				}
			}),

			this.storage.get(GlobalConstants.STORAGE_KEY_TEILNEHMERSPEZIFISCHES).then((teilnehmerspezifisches : eGENA_Teilnehmerspezifisches) => {
				this.teilnehmerBezeichnung = teilnehmerspezifisches?.TeilnehmerBezeichnung;
				this.teilnehmerOrt = teilnehmerspezifisches?.TeilnehmerOrt;
			})
		]).then(() => {
			console.log("Einträge aus dem lokalen Speicher geholt");
			this.isLoaded = true;
		});
	}


	/**	=== Visionet(sl) ==========
	 *	Für den Fall, dass wir keine Verbindung zum Server bekommen versuchen wir die ganzen Indizes aus dem lokalen Speicher zu holen
	 *	Dazu speichern wir uns ein Array mit allen Checklisten-IDs.
	 */
	storeCreatedIndices(currentVersion : string, teilnehmerkennung : string) : void {
		/** (ds)
		 * Promise.all hat als Paramter ein Array von Promises. Then wird dann ausgeführt, 
		 * wenn alle Promises "erfüllt" wurden, d.h. dass die callback-Funktion für then nur
		 * dann ausgeführt wird, wenn alle DB-Einträge gelöscht sind.
		 */
		Promise.all([
			this.storage.remove(GlobalConstants.STORAGE_KEY_AKTUELLE_VERSION),
			this.storage.remove(GlobalConstants.STORAGE_KEY_CHECKLIST_INDEX)
		]).then(() => {
			this.storage.set(GlobalConstants.STORAGE_KEY_AKTUELLE_VERSION,currentVersion)
			this.storage.set(GlobalConstants.STORAGE_KEY_TEILNEHMERKENNUNG, teilnehmerkennung)
			this.storage.set(GlobalConstants.STORAGE_KEY_CHECKLIST_INDEX, this.checklistIndex)
			console.info("Speichere Teilnehmerkennung '" + teilnehmerkennung + "' und aktuelle Version '" + currentVersion + "'");
		});
	}


	/**	=== Visionet(sl) ==========
	 *	Holt per `MiddlewareService` alle Checklisten vom Server. Wir holen immer ALLE Cehcklisten. Wir ermitteln keine Deltas oder sonstige
	 *	Änderungen. Immer ALLES.
	 *	Die Funktion läuft im Prinzip asynchron. Erst am Ende wird `this.isLoaded`auf true gesetzt.
	 *	So weit ich das verstanden habe wird dann der Inhalt der Seite est dann angezeigt wenn die Bedingung "ngIf=isLoaded" erfüllt ist.
	 *	So lange isLoaded nicht true ist wird das eGENA-Logo mit einem Hinwqeis auf Datenübertragung angezeigt.
	 */
	loadNewChecklists(teilnehmerkennung : string) : void {
		console.info("Startseite.loadNewChecklists(): teilnehmerkennung = '" + teilnehmerkennung + "' per URL '" + this.checklistService.getDataUrl(teilnehmerkennung) + "'");
		this.checklistService.getData(teilnehmerkennung).subscribe(teilnehmerdatensatz => {
			console.time("daten Abrufen");
			console.log("\tSpeicher löschen...");
			if ('Fehler' in teilnehmerdatensatz && teilnehmerdatensatz.Fehler !== undefined && teilnehmerdatensatz.Fehler !== "") {
				this.isLoaded = false;
				let errormessage = 
					this.globals.translate('ERR.Das Laden der Checklisten vom Server schlug fehl.') + '\n' +
					this.globals.translate('ERR.Wir behelfen uns, falls vorhanden, mit der zuletzt geladenen Fassung.') + '\n\n' +
					this.globals.translate('ERR.Fehler') + ':\n' +
					teilnehmerdatensatz.Fehler
				;
				console.error(errormessage);
				alert(errormessage);
	
				this.indizesAusStorageNeuGenerieren(errormessage);
				return;
			}
			this.storage.clear().then(() /* resolve */ => {
				// Alle Checklisten Indizieren
				console.log("\tVom Server erhaltene Daten indizieren...");
				for (const checkliste of eGENA_Checkliste.fromArray(teilnehmerdatensatz.Checklisten)) {
					this.checklisteIndizieren(checkliste)
				}
				this.chcklistenIndizesGlobalSpeichern();
				this.teilnehmerBezeichnung = teilnehmerdatensatz.Teilnehmerspezifisches?.TeilnehmerBezeichnung;
				this.teilnehmerOrt = teilnehmerdatensatz.Teilnehmerspezifisches?.TeilnehmerOrt;

				this.storeCreatedIndices(teilnehmerdatensatz.Versionen, teilnehmerdatensatz.Teilnehmerspezifisches.Teilnehmerkennung);

				Promise.all([
					this.storage.remove(GlobalConstants.STORAGE_KEY_TEILNEHMERSPEZIFISCHES),
				]).then(() => {
					this.storage.set(GlobalConstants.STORAGE_KEY_TEILNEHMERSPEZIFISCHES, teilnehmerdatensatz.Teilnehmerspezifisches);
					this.storage.set(GlobalConstants.STORAGE_KEY_TEILNEHMERKENNUNG, teilnehmerdatensatz.Teilnehmerspezifisches.Teilnehmerkennung);
					this.storage.set(GlobalConstants.STORAGE_KEY_AKTUELLE_VERSION, teilnehmerdatensatz.Versionen);
					this.storage.set(GlobalConstants.STORAGE_KEY_RECHTLICHES, teilnehmerdatensatz.Rechtliches);

					this.zeigeHaftungsausschluss();

					console.info("Speichere Teilnehmerkennung '" + teilnehmerdatensatz.Teilnehmerspezifisches.Teilnehmerkennung + "' und aktuelle Version '" + teilnehmerdatensatz.Versionen + "'");
					console.timeEnd("daten Abrufen");
				});
	
				this.isLoaded = true;
			}, // ende then
			reason /* reject */ => {
				this.isLoaded = false;
				let msgPrefix : string = this.globals.translate('ERR.Fehler beim Löschen der lokalen Browserdatenbank');
				console.error(msgPrefix + ': ' + reason);
				alert(msgPrefix + ':\n' + reason);
			});
		},
		error => {
			this.isLoaded = false;
			let errormessage =
				this.globals.translate('ERR.Das Laden der Checklisten vom Server schlug fehl.') + '\n' +
				this.globals.translate('ERR.Wir behelfen uns, falls vorhanden, mit der zuletzt geladenen Fassung.') + '\n\n' +
				this.globals.translate('ERR.Fehler') + ':\n' +
				JSON.stringify(error, null, 4)
			;
			console.log(errormessage);
			alert(errormessage);

			this.indizesAusStorageNeuGenerieren(errormessage);
		})
		;

		console.info("Laden und Indizieren der Daten abgeschlossen");
	}	


	/**	=== Visionet(sl) ==========
	 *	Bekommt eine Checkliste vorgesetzt und baut dann einen Index für die verschiedenen Such-Möglichkeiten auf
	 *	Außerdem wird die Checkliste im globalen Speicher `this.storage` mit dem Hash-Index "ch_<ID>" gespeichert
	 * 
	 * @param checkliste 
	 */
	checklisteIndizieren(checkliste : eGENA_Checkliste) : void {
		// Erzeuge Index für ABCDE-Problem-Suche
		for (const tag of checkliste.problemkategorienAsArray()) {
			if (this.abcdeIndex[tag] == undefined) {
				this.abcdeIndex[tag] = []
			}
			this.abcdeIndex[tag].push(checkliste);
		}

		// Dann der Index für die Körpernavigator-Suche
		// create bodynavIndex
		for (const tag of checkliste.körpernavigator) {
			if (this.bodynavIndex[tag] == undefined) {
				this.bodynavIndex[tag] = []
			}
			this.bodynavIndex[tag].push(checkliste);
		}

		// Index Reanimation
		if (checkliste.reanimation) {
			this.reanIndex.push(checkliste);
		}

		// Erster Buchstabe des Titels für die Textsuche
		let checklistLetter = checkliste.titel.charAt(0)

		if (this.azIndex[checklistLetter] == undefined) {
			this.azIndex[checklistLetter] = []
		}

		this.azIndex[checklistLetter].push(checkliste);
		this.fuzzySearchIndex.push(checkliste);
		this.checklistIndex.push(checkliste.id)

		//store checklist
		this.storage.set(checkliste.id.toString(), checkliste)
	}


	chcklistenIndizesGlobalSpeichern() : void {
		this.globals.setAbcdeIndex(this.abcdeIndex);
		this.globals.setAzIndex(this.azIndex);
		this.globals.setBodynavIndex(this.bodynavIndex);
		this.globals.setFuzzySearchIndex(this.fuzzySearchIndex);
	}

	/**	=== Visionet(sl) ==========
	 *
	 *	Klick auf Patientengruppe (Kind, Erwachsener, Schwangere)
	 */
	setPatientType(patientType : string) : void {
		this.ausgewaehlterPatiententyp = patientType
	}







	/**	=== Visionet(sl) ==========
	 *
	 *	Klick auf Suchtyp Textsuche
	 */
	setActiveSearchToTextSearch() : void {
		this.curSearchResultChecklists = []
		this.onSuchtypSelected("search");
	}


	/**	=== Visionet(sl) ==========
	 *	Zurück zur Startseite
	 */
	goHome(event : UIEvent) : void {
		this.navCtrl.goToRoot( {
			animate : true,
			animation: "ios-transition"
			}
		);
	}







	async getTeilnehmerkennungFromStorage() : Promise<string> {
		let ret = await this.storage.get(GlobalConstants.STORAGE_KEY_TEILNEHMERKENNUNG).then((teilnehmerkennung : string) => {
			if (teilnehmerkennung) {
				return teilnehmerkennung;
			}
		})

		return ret;
	}



	/**	Der Parameter ?teilnehmerkennung=12345678 am Ende der URL muss weg.
	 */
	private urlBereinigen() : string {
		let newUrl : string = window.location.href.replace(/\/[\?#]+teilnehmer=.*/gi, "");
		window.location.replace(newUrl);
		return newUrl;
	}




	
	/**	=== Visionet(sl) ==========
	 *	Der Suchtyp wurde ausgewäshlt, weiter gehts zur passenden Auswahlseite
	 *	Um aus den passenden Cehcklisten eine auszuwählen
	 */
	onSuchtypSelected(activeSearch : string) : void {
		this.globals.setCurSearchResultChecklists(this.curSearchResultChecklists);
		this.navCtrl.push(SearchPhoneSelectListPage, {
			activeSearch: activeSearch,
			ausgewaehlterPatiententyp: 	this.ausgewaehlterPatiententyp
			},
			{
				animate : true,
				animation: "ios-transition"
			}
		);
		this.ausgewaehlterPatiententyp = "";
		this.curSearchResultChecklists = [];
		this.activeSearch = "";
	}



}



// WEBPACK FOOTER //
// ./src/pages/search/Phone/SearchPhoneStartPage.ts